import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isCurrentAuthSession } from '../api/authenticatedRequest';
import { clearAuthSession } from '../store/userSlice';
import AccountRefreshNotice from './AccountRefreshNotice';
import LoginModal from './LoginModal';

// Mounted outside Layout so both the header and sidebar routes have a login entry.
export default function OrderAuthListener() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user.user);
  const [notice, setNotice] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);
  const closeNotice = useCallback(() => setNotice(null), []);

  useEffect(() => {
    const onRefreshFailed = ({ detail }) => {
      if (detail && isCurrentAuthSession(detail, true)) setNotice(detail);
    };
    const onSessionExpired = ({ detail }) => {
      if (!detail || !isCurrentAuthSession(detail, true)) return;
      setNotice(null);
      dispatch(clearAuthSession());
      navigate('/');
      setLoginOpen(true);
    };
    const onStorage = () => {
      setNotice(current => current && isCurrentAuthSession(current, true) ? current : null);
    };
    window.addEventListener('auth:token-refresh-failed', onRefreshFailed);
    window.addEventListener('auth:session-expired', onSessionExpired);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('auth:token-refresh-failed', onRefreshFailed);
      window.removeEventListener('auth:session-expired', onSessionExpired);
      window.removeEventListener('storage', onStorage);
    };
  }, [dispatch, navigate]);

  useEffect(() => { setNotice(null); }, [user]);

  const relogin = () => {
    if (notice && isCurrentAuthSession(notice, true)) setLoginOpen(true);
    closeNotice();
  };

  return <>
    {notice && <AccountRefreshNotice onClose={closeNotice} onLogin={relogin} />}
    <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} onLogin={() => setLoginOpen(false)} />
  </>;
}
